import React from 'react';
import styled from 'styled-components';
import theme from '../../../shared/theme';

export const PopupArrow = styled.div`
    position: absolute;
    top: -10px;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid ${theme.app.backgroundColorBase};
`;

export const PopupMenuMiddle = styled.div`
    & > :first-child {
        padding-top: 20px;
    }

    & > :last-child {
        padding-top: 10px;
        padding-bottom: 20px;
    }
`;

export const PopupMenuItem = styled.a<{ $isHeader?: boolean }>`
    padding: 5px;
    margin: 2px;
    display: flex;
    word-break: keep-all;
    align-items: center;
    justify-content: left;
    text-decoration: none;
    cursor: pointer;
    color: ${theme.app.primary};
    font-family: ${theme.app.font};

    ${(props) => (props.$isHeader ? `font-weight: ${theme.font.black};` : `font-weight: ${theme.font.regular};`)};
    ${(props) => (props.$isHeader ? `font-size: 14px;` : `font-size: 13px;`)};
    ${(props) => (props.$isHeader ? `text-transform: uppercase;` : null)};
    ${(props) => (props.$isHeader ? 'min-height: 55px;' : 'min-height: 25px;')};
    ${(props) => (props.$isHeader ? 'padding-bottom: 30px;' : null)};
    ${(props) => (props.$isHeader ? 'cursor: default;' : 'cursor: pointer;')};

    overflow: hidden;

    :hover {
        filter: alpha(opacity=70);
        opacity: 0.7;
    }
`;

export const ContanierLanguageMenu = styled.div<{ $isVisible: boolean }>`
    position: absolute;
    top: 44px;
    right: -130px;
    width: 250px;
    height: 230px;
    z-index: 2;
    padding: 25px;
    background-color: ${theme.app.backgroundColorBase};
    ${(props) => (props.$isVisible ? null : 'display: none')};
    border-radius: 10px;
    box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
`;

export const TriangleLanguageMenu = styled.div`
    position: absolute;
    top: -10px;
    right: 140px;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid ${theme.app.backgroundColorBase};
`;

export const ItemLanguagePopupMenu = styled.div`
    padding: 5px;
    overflow-y: auto;
    height: 180px;

    ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-track {
        background: ${theme.app.backgroundColor};
        border-radius: 20px;
    }

    ::-webkit-scrollbar-thumb {
        background: ${theme.app.secondary};
        border-radius: 20px;
    }

    scrollbar-color: ${theme.app.secondary} ${theme.app.backgroundColor};
    scrollbar-width: thin;
`;

export const MenuAccountContainer = styled.div<{ $width?: number; $align: 'left' | 'right' }>`
    position: absolute;
    top: 40px;
    width: 330px;
    overflow-y: auto;
    z-index: 10000;
    background-color: ${theme.app.backgroundColorBase};
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

    ${(props) =>
        props.$align === 'right' &&
        `
        right: 0;

        ${PopupArrow} {
            right: 10px;
        }
    `}

    ${(props) =>
        props.$align === 'left' &&
        `
        left: 0;

        ${PopupArrow} {
            left: 10px;
        }
    `}

	&::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
        margin-right: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(207, 216, 220);
        border-radius: 10px;
        transition: background 0.3s ease;
    }

    &:not(:hover)::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0);
    }
`;

const ItemAccountMenuContainer = styled.a<{ hasDashedLine?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 10px 20px;
    border-radius: 4px;
    transition: background-color 0.2s;
    text-decoration: none;
    position: relative;
    flex-shrink: 0;
    width: auto;
    max-width: none;
    background-color: #ffffff;

    &::after {
        content: '';
        display: ${(props) => (props.hasDashedLine ? 'block' : 'none')};
        position: absolute;
        bottom: 0;
        left: 16px;
        right: 16px;
        border-bottom: 1px solid #f3f5f6;
    }

    &:hover {
        cursor: pointer;
        filter: alpha(opacity=70);
        opacity: 0.7;
        width: auto;
    }
`;

const MenuTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: auto;
    flex: 1;
    white-space: nowrap;
`;

const IconItemMenu = styled.div`
    display: flex;
    align-items: top;
    justify-content: center;
    text-align: center;
    background-color: #ffffff;
    width: 36px;
    height: 36px;
    margin-right: 12px;
    flex-shrink: 0;
    cursor: pointer;
    color: #ffffff;
    padding: 0;
    box-sizing: border-box;
`;

const MenuTitle = styled.div<{ titleCss?: React.CSSProperties; titleHoverCss?: React.CSSProperties }>`
    font-weight: normal;
    font-size: 14px;
    color: #000;
    ${(props) => props.titleCss && { ...props.titleCss }}
    text-decoration: none;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    overflow: hidden;

    &:hover {
        ${(props) => props.titleHoverCss && { ...props.titleHoverCss }}
    }
`;

const MenuDescription = styled.div<{ descriptionCss?: React.CSSProperties }>`
    font-size: 12px;
    color: #445a64;
    margin-top: 2px;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    overflow: hidden;
    ${(props) => props.descriptionCss && { ...props.descriptionCss }}
`;

export const FooterMenu = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background-color: #fafbfb;
    padding: 8px 20px;
    font-size: 10px;
    color: #445a64;
    white-space: nowrap;
    text-align: center;
    border-radius: 0 0 8px 8px;

    a {
        text-decoration: none;
        color: ${theme.app.primary};
        font-size: 12px;

        &:hover {
            text-decoration: underline;
        }
    }
`;

interface AccountMenuItemProps {
    icon?: React.ReactNode;
    title: string;
    description?: string;
    href?: string;
    onClick?: () => void;
    titleCss?: React.CSSProperties;
    titleHoverCss?: React.CSSProperties;
    descriptionCss?: React.CSSProperties;
    hasDashedLine?: boolean;
}

export const AccountMenuItem: React.FC<AccountMenuItemProps> = ({
    icon,
    title,
    description,
    href,
    onClick,
    titleCss,
    titleHoverCss,
    descriptionCss,
    hasDashedLine = false
}) => {
    return (
        <ItemAccountMenuContainer
            as={href ? 'a' : 'div'}
            href={href || undefined}
            onClick={onClick}
            target={href?.startsWith('http') ? '_blank' : undefined}
            rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
            hasDashedLine={hasDashedLine}
        >
            {icon && <IconItemMenu>{icon}</IconItemMenu>}
            <MenuTitleContainer>
                <MenuTitle titleCss={titleCss} titleHoverCss={titleHoverCss}>
                    {title}
                </MenuTitle>
                {description && <MenuDescription descriptionCss={descriptionCss}>{description}</MenuDescription>}
            </MenuTitleContainer>
        </ItemAccountMenuContainer>
    );
};
